import { Injectable } from "@angular/core"
import { 
  BannerHomeDto, 
  FindBannerHomeDto, 
  CreateBannerHomeDto, 
  PageResultDto 
} from "../../dto"
import { HttpService } from "../http.service"
import { ADMIN_API_ENDPOINTS } from "../../common/api-endpoints"


@Injectable()
export class AdminBannerHomeService {
  constructor(
    private httpService: HttpService
    ) {
  }

  async find(params: FindBannerHomeDto) {
    return await this.httpService.get<PageResultDto<BannerHomeDto>>(ADMIN_API_ENDPOINTS.BANNER_HOME, params)
  }

  async update(id: string, updateBannerOnboardDto: CreateBannerHomeDto) {
    return await this.httpService.put<Boolean>(`${ADMIN_API_ENDPOINTS.BANNER_HOME}/${id}`, updateBannerOnboardDto)
  }

  async create(createBannerOnboardDto: CreateBannerHomeDto) {
    return await this.httpService.post<Boolean>(ADMIN_API_ENDPOINTS.BANNER_HOME, createBannerOnboardDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`${ADMIN_API_ENDPOINTS.BANNER_HOME}/${id}`)
  }
} 